module.exports = __webpack_public_path__ + "fonts/TT-Norms_Medium.91cdf33.woff";